<template>
  <div>
    <el-table
      class="common-el-table-styles"
      ref="table"
      v-loading="loading"
      :data="data"
      :height="height"
      border
      stripe
      @selection-change="changeSelection"
    >
      <el-table-column type="selection" width="47" :selectable="rowSelectable"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :fixed="col.fixed"
      >
        <template slot-scope="{ row }">
          <span v-if="col.key === 'createTime'">{{ row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'intelligentProjectId'">{{ row[col.key] || '——' }}</span>
          <span v-else-if="col.key === 'planName'">
            <el-button type="text" v-clipboard:copy="row[col.key]" v-clipboard:success="onCopy" v-clipboard:error="onError">
              {{ row[col.key] }}
            </el-button>
          </span>
          <span v-else-if="col.key === 'updateTime'">{{ row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'taskStatus'">{{ row[col.key] | transResult(row) }}</span>
          <div v-else-if="col.key === 'control'">
            <span v-if="row['taskStatus'] === 3">
              <ElButton @click="toRetryTask(row)" type="text">重试</ElButton>
              <ElButton v-if="row.materialError" :loading="row.failMsgLoading" @click="getFailMsgDetail(row)" type="text"
                >失败详情
              </ElButton>
            </span>
          </div>
          <div v-else-if="col.key === 'mediaName'">
            <span>{{ row[col.key] }}</span>

            <template v-if="row.mediaId === 16">
              <span class="tencent-tag" v-if="row.version === 'Gdtv1'">v1</span>
              <span class="tencent-tag" v-else-if="row.version.includes('ADA')">ADA</span>
              <span class="tencent-tag" v-else-if="row.version === 'Gdtv3'">v3</span>
            </template>
          </div>

          <span v-else>{{ row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="素材失败详情" :visible.sync="materialFailModal" width="550px">
      <el-table class="common-el-table-styles" :data="materialFailList" :height="200" border stripe>
        <el-table-column width="110" label="素材名称">
          <template slot-scope="{ row }">
            <el-button type="text" v-clipboard:copy="row.material_name" v-clipboard:success="onCopy" v-clipboard:error="onError">
              {{ row.material_name }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column width="70" prop="type" label="素材类型"></el-table-column>
        <el-table-column width="80" prop="material_rate" label="素材尺寸"></el-table-column>
        <el-table-column width="70" prop="material_size" label="素材大小"></el-table-column>
        <el-table-column show-overflow-tooltip prop="up_msg" label="失败信息"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="materialFailModal = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { retryTask, getTaskMaterialFailMsg } from '@/api/manage.model'
export default {
  name: 'batchadTable',
  props: {
    value: {
      type: Array
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    height: {
      type: Number,
      default: 500
    },
    columns: {
      type: Array
    }
  },
  computed: {
    selection: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    rowSelectable() {
      return (row) => {
        // 成功的任务也需要允许勾选，用于批量复制
        return [2, 3].includes(row.taskStatus)
      }
    }
  },
  methods: {
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    },
    getFailMsgDetail(row) {
      this.$set(row, 'failMsgLoading', true)
      const { taskId } = row
      getTaskMaterialFailMsg({ taskId })
        .then((data) => {
          if (data?.length) {
            this.materialFailList = data
            this.materialFailModal = true
          }
        })
        .finally(() => {
          this.$set(row, 'failMsgLoading', false)
        })
    },
    toRetryTask(row) {
      const { taskId } = row
      this.$emit('on-loading', true)
      retryTask({ taskId })
        .then((data) => {
          this.$emit('on-loading', false)
          if (data) {
            this.$emit('on-refresh')
            this.$Message.success('重试完成！')
          } else {
            this.$emit('on-refresh')
            this.$Message.error('重试失败！')
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    changeSelection(selection) {
      this.$emit('input', selection)
    },
    clearSelection() {
      this.$refs.table.clearSelection()
    }
  },
  data() {
    return { materialFailModal: false, materialFailList: [] }
  },
  filters: {
    transResult(val, row) {
      let msgInfo
      switch (val) {
        case 0:
          msgInfo = '未开始'
          break
        case 1:
          msgInfo = '进行中'
          break
        case 2:
          msgInfo = '成功'
          break
        case 3:
          msgInfo = '失败,' + row.failMsg
          break
        default:
          msgInfo = '未知'
          break
      }
      return msgInfo
    }
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
.tencent-tag {
  display: inline-block;
  font-size: 12px;
  transform: scale(0.7);
  background: #1974ff;
  opacity: 0.7;
  color: #fff;
  padding: 2px 4px;
  border-radius: 2px;
  margin-left: 2px;
}
</style>
